import React, { useState } from "react";
import { createPortal } from "react-dom";

function SuspendPrompt({ activity, onConfirm, onCancel, saving = false }) {
  const [remark, setRemark] = useState("");
  const [error, setError] = useState("");

  const handleConfirm = () => {
    if (!remark.trim()) {
      setError("A remark is required.");
      return;
    }
    onConfirm(remark.trim());
  };

  return createPortal(
    <div
      className="modal-overlay"
      role="presentation"
      onMouseDown={() => !saving && onCancel()}
    >
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        onMouseDown={(e) => e.stopPropagation()}
        style={{ maxWidth: 460 }}
      >
        <div className="modal-header">
          <h3>
            <i
              className="fas fa-pause-circle"
              style={{ color: "#d97706", marginRight: 8 }}
            />
            Suspend Next Contact
          </h3>
        </div>

        <div className="modal-body">
          <div style={{ marginBottom: 12, color: "#6b7a8a", fontSize: 13 }}>
            {activity?.activity_type} · {activity?.planned_date}
          </div>

          <div className="form-group">
            <label>
              Reason <span className="required">*</span>
            </label>
            <textarea
              className="form-control"
              rows="3"
              value={remark}
              onChange={(e) => {
                setRemark(e.target.value);
                if (error) setError("");
              }}
              placeholder="Why are you suspending this?"
              disabled={saving}
            />
            {error && <div className="error-text">{error}</div>}
          </div>
        </div>

        <div className="modal-footer" style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onCancel}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleConfirm}
            disabled={saving}
          >
            {saving ? (
              <>
                <i className="fas fa-spinner fa-spin" /> Saving...
              </>
            ) : (
              "Suspend"
            )}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}

export default SuspendPrompt;